// ボタン、モーダル、モーダルの閉じるボタン、オーバーレイを変数に格納
const modal = document.querySelector('.l-modal');
const closeBtn = document.querySelector('.l-modal__hamburger');
const overlay = document.querySelector('.l-modal__overlay');
const body = document.querySelector('body');
const modalBtn = $('#js-modal-hamburger')
const modalMoreBtn = $('.js-more-btn')
const submitBtn = document.getElementById("js-submitBtn");
const selectInner = document.querySelector('.l-modalSelect__inner');
const labelItems = document.querySelectorAll('.l-modalSelect__item');
const chartBtns = document.querySelectorAll('.js-chart-btn')

//モーダルのハンバーガーボタンを押したらナビ開閉
modalBtn.click(function(){
	$('html').toggleClass('is-fixed')
	modalBtn.removeClass('is-open')
})

//モーダル内の詳細をみるボタンを押したらモーダル閉
modalMoreBtn.click(function(){
	$('html').removeClass('is-fixed')
	$('.l-modal').removeClass('is-active')
	$('.l-modal__overlay').removeClass('is-active')
	selectInner.classList.remove('is-hidden')
	selectInner.classList.add('is-active')
})

// kv下の診断ボタンをクリック時の挙動
chartBtns.forEach(function(chartBtn) {
  chartBtn.addEventListener('click', function(e) {
    e.preventDefault(); // aタグのデフォルトの機能を停止する
    modal.classList.add('is-active');
    overlay.classList.add('is-active');
    body.classList.add('is-fixed');
    $('html').addClass('is-fixed');
    chartBtn.classList.remove('is-open');
		submitBtn.classList.remove("is-active");

    // labelItemsの各要素に対してis-activeクラスがあるかチェック
    labelItems.forEach(function(label) {
      if (label.classList.contains('is-active')) {
        label.classList.remove('is-active');
      }
    });
		//診断リストの項目 ランダムに並び替え
		function shuffleContent(container) {
			var content = container.find("> *");
			var total = content.length;
			content.each(function() {
				content.eq(Math.floor(Math.random() * total)).prependTo(container);
			});
		}
		$(function() {
			shuffleContent($(".l-modalSelect__list"));
		});
  });
});


// 各label要素に対してクリックイベントを追加
labelItems.forEach(function(label) {
  label.addEventListener('click', function() {
    labelItems.forEach(function(otherLabel) {
      otherLabel.classList.remove('is-active');
      // otherLabel.classList.add('is-disabled');
    });
    label.classList.add('is-active');
		submitBtn.classList.add("is-active");
  });
});

// モーダルの閉じるボタンをクリックしたら、モーダルとオーバーレイのactiveクラスを外す
closeBtn.addEventListener('click', function(){
  modal.classList.remove('is-active');
  overlay.classList.remove('is-active');
  body.classList.remove('is-fixed');
	selectInner.classList.remove('is-hidden');
	labelItems.classList.remove('is-active');
});

// オーバーレイをクリックしたら、モーダルとオーバーレイのactiveクラスを外す
overlay.addEventListener('click', function() {
  modal.classList.remove('is-active');
  overlay.classList.remove('is-active');
  body.classList.remove('is-fixed');
});

// モーダル内の診断するボタンを押した時の挙動
submitBtn.addEventListener("click", function () {
	// selectInner.style.display = "none";
	selectInner.classList.add('is-hidden');

	const selectedOption = document.querySelector('input[name="select"]:checked');
	if (selectedOption) {
		const selectedRecommendClass = selectedOption.parentElement.getAttribute("data-recommend");
		const selectedRecommendInner = document.querySelector('.l-modalRecommend__inner.-' + selectedRecommendClass);

		// すべての .l-modalRecommend__inner を非表示にする
		const allRecommendInners = document.querySelectorAll('.l-modalRecommend__inner');
		allRecommendInners.forEach(function (inner) {
			inner.style.display = "none";
		});

		// 選択されたアイテムに対応する .l-modalRecommend__inner を表示
		if (selectedRecommendInner) {
			selectedRecommendInner.style.display = 'block';
			selectedRecommendInner.classList.add('is-active');
		}
	}
});

